/**
 * `file` → **Settings** (spec M1-B5 §6.2, card P-123).
 *
 * `file`'s captured `Settings` submenu (`editors/file/dialog-settings-0.json`) has no *Customize*
 * row, and `fileSettingsSchema` is `{hide_footer}` — files are added with `add_file_to_column`
 * and the column itself holds no configuration (spec M2 tier-2 §5.4).
 */
import type { FileSettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function FileSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<FileSettings>) {
  const [draft, patch] = useSettingsDraft<FileSettings>(settings);
  return (
    <SettingsForm
      title="Files column settings"
      testId="file-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <HideSummaryField
        divider={false}
        testId="file-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
